import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

/**
 * Homepage entry-point that funnels craft-entrepreneur interest to
 * /become-a-partner. Placed near the bottom of the home page.
 *
 * Copy mirrors the "Chaleur Global Channel Partners" brand voice.
 */
const HomepagePartnerCTA = () => {
  return (
    <section className="bg-foreground text-background py-24 md:py-32" data-testid="home-partner-cta">
      <div className="chaleur-container grid md:grid-cols-12 gap-10 md:gap-16">
        <div className="md:col-span-6 animate-fade-in-up">
          <p className="text-xs tracking-[0.3em] uppercase text-background/60 mb-8">
            Chaleur Global Channel Partners
          </p>
          <h2 className="editorial-italic text-4xl md:text-6xl leading-[1.05] mb-10">
            Local hands.<br /> Global stories.
          </h2>
          <p className="text-background/70 leading-relaxed text-base md:text-lg max-w-lg mb-10">
            A curated global platform for established craft entrepreneurs — bringing regional
            artistry to discerning markets while creating shared prosperity.
          </p>
          <Link
            to="/become-a-partner"
            className="inline-flex items-center gap-2 text-sm tracking-widest uppercase border-b border-background pb-1 hover:opacity-60 transition-opacity"
            data-testid="home-partner-cta-btn"
          >
            Partner with us <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="md:col-span-6 grid grid-cols-1 gap-4 self-center animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
          {[
            { t: 'Discover', d: 'Credible craft entrepreneurs and distinctive regional capabilities.' },
            { t: 'Develop', d: 'Design mentors strengthen product, presentation and readiness.' },
            { t: 'Curate', d: 'Coherent collections for a market, occasion and audience.' },
            { t: 'Lift', d: 'Every sale circulates value through maker, partner, platform and impact.' },
          ].map((s) => (
            <div key={s.t} className="border border-background/20 p-6 flex gap-6 items-baseline">
              <span className="editorial-italic text-2xl shrink-0 w-24">{s.t}</span>
              <span className="text-sm text-background/70 leading-relaxed">{s.d}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomepagePartnerCTA;
